export const folder_minus = () => (
  <path
    d="M9 14h6m7 5a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2v11z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
